import { useMutation } from '@tanstack/react-query';

import { client } from './';
import supabase from '../../../sdk/api';

type Keys = {
  query: string;
  index: string;
  category?: string;
};

export const getSearchIndex = async (query: string, index: string, category?: string) => {
  const api = client.initIndex(index);
  const { data: userData } = await supabase.auth.getSession();
  // Настройка сеттингов делается единоразово
  await api.setSettings({
    attributesForFaceting: ['category_id'],
  })

  const { data: recent } = await supabase
    .from('user_recent_queries')
    .select('*')
    .eq('user_id', userData.session?.user.id)
    .eq('query', query)

  if (query && !recent?.length) {
    await supabase.from('user_recent_queries').insert({
      user_id: userData.session?.user.id,
      query,
    });
  }

  const data = await api.search(query, {
    filters: category ? `category_id:${category}` : '',
  });
  const mappedData: any[] = []

  // salons_profiles
  if (index === 'salons_profiles') {
    const objectIDs = data.hits?.map((d: any) => d.objectID)
    const { data: profiles } = await supabase
      .from('user_profiles')
      .select('*')
      .in('id', objectIDs)

    data.hits?.forEach((d: any) => {
      mappedData.push({ ...d, bg_video: profiles?.find((a: any) => a.id === d.objectID)?.bg_cover })
    })
  }
  // salons_profiles

  // assets
  if (index === 'assets') {
    const ids = data.hits?.map((d: any) => d.id)
    const { data: assets } = await supabase
      .from('assets')
      .select(`
        *,
        category:categories(*)
      `)
      .in('id', ids)
    data.hits?.forEach((d: any) => {
      mappedData.push({ ...d, details: assets?.find((a: any) => a.id === d.id) })
    })

    return mappedData;
  }
  // assets

  // posts
  if (index === 'posts') {
    const ids = data.hits?.map((d: any) => d.objectID)

    const { data: posts } = await supabase
      .from('posts')
      .select(`
        *,
        category:categories(*),
        profile:user_profiles (id, username),
        assetPrices:posts_assets (price_time_posting, asset_id),
        assets:assets!posts_assets (
          *,
          category:categories(*)
      )`)
      .in('id', ids)
    data.hits?.forEach((d: any) => {
      mappedData.push({ ...d, details: posts?.find((a: any) => a.id === d.objectID) })
    })

    return mappedData;
  }
  // posts

  data.hits?.forEach((d: any) => {
    mappedData.push({ ...d })
  })
  return mappedData;
};
export default function useGetIndexByQuery() {
  return useMutation(
    ({ query, index, category }: Keys) => getSearchIndex(query, index, category),
    {
      onSuccess: async (data) => data,
    },
  );
}
